import {styled} from "@mui/material/styles"
import {InputBase} from "@mui/material"

export const SearchBar = styled("div")`
    display: flex;
    height: 2.25rem;
    width: 100%;
    margin: 0;
    align-items: center;
    border-radius: ${({theme}) => `${theme.colours.form.input.borderRadius}`};
    padding: 0.5rem 0.75rem 0.5rem 0;
    border: ${({theme}) => `0.0625rem solid ${theme.colours.action.default.enabled.borderColor}`};
    background-color: ${({theme}) => theme.colours.action.default.enabled.background};

    &:focus-within {
        outline: ${({theme}) => `0.0625rem solid ${theme.colours.action.focused.border}`};
    }

    // Fix for IOS devices
    @supports (-webkit-touch-callout: none) {
        &:focus-within {
            border: ${({theme}) => `0.0625rem solid ${theme.colours.action.focused.border}`};
            outline: none;
        }
    }
`

export const Input = styled(InputBase)`
    width: 100%;
    font-size: 1rem;
    color: ${({theme}) => theme.colours.light.text.secondary};
    font-size: ${({theme}) => theme.colours.typography.body1.fontSize};

    input {
        font-family: ${({theme}) => theme.colours.components.inputText.fontFamily};
        font-weight: ${({theme}) => theme.colours.components.inputText.fontWeight};
        font-size: ${({theme}) => theme.colours.components.inputText.fontSize};
        line-height: ${({theme}) => theme.colours.components.inputText.lineHeight};
        max-width: 9.5rem;
        margin: 0 1rem;
        &::-ms-clear {
            display: none;
        }
    }
`
export const SearchIcon = styled("div")`
    && {
        padding: 0;
        height: 1.25rem;
        width: 1.25rem;

        &:hover,
        &:active {
            border: 0;
        }

        &:focus {
            border: 0;
            border-radius: 0;
        }
    }
`
export const ClearIcon = styled("div")`
    position: absolute;
    right: 1.75rem;
    && {
        padding: 0;
        background: #ffffff;
        height: 1.25rem;
        width: 1.25rem;
        min-width: auto;

        &:hover,
        &:active {
            background: ${({theme}) => theme.colours.form.input.background};
            border: 0;
        }

        &:focus {
            border: 0;
            border-radius: 0;
        }
    }
`
export const Icon = styled("img")`
    cursor: pointer;
`
